import AuthContainer from '@/components/auth/AuthContainer';
import SignUpForm from '@/components/auth/SignUpForm';
import TermsAndConditions from '@/components/auth/legal-links/TermsAndConditions';
import { useAuthProvider } from '@/hooks/auth/useAuthProvider';

export default function SignUp() {
	const { handleSignUp, loadingState } = useAuthProvider();

	return (
		<AuthContainer>
			<div className="flex flex-col items-center justify-center h-full w-full p-8 mt-8">
				<div className="bg-white rounded-2xl glassy-shadow-inset-outward p-8 w-full min-h-[50vh] flex items-center justify-center">
					<div
						className="w-full flex flex-col items-center justify-center"
						data-testid="signup-page"
					>
						<p className="text-2xl text-center mb-6 mt-2 font-bold">
							Merchant Sign-up
						</p>

						<div className="w-full max-w-sm">
							<SignUpForm
								handleSubmit={handleSignUp}
								loading={loadingState.signUp}
							/>
						</div>
					</div>
				</div>
				<div className="w-full max-w-sm text-center mt-4">
					<TermsAndConditions />
				</div>
			</div>
		</AuthContainer>
	);
}
